import { UI_MediaSpot } from 'ui/components/3-organisms/MediaSpot/MediaSpot';

export const MediaSpotFeature: React.FC<Content.MediaSpot> = ({ content, settings }) => {
	return (
		<UI_MediaSpot
			bgColor={content?.properties?.color}
			showControls={content?.properties?.showControls}
			isMuted={content?.properties?.isMuted}
			heading={content?.properties?.headline}
			trumpetHeading={content?.properties?.kickerFirstWord}
			contentHeading={content?.properties?.textHeading}
			contentParagraph={content?.properties?.text}
			readMoreText={content?.properties?.readMoreText}
			readMoreButtonText={content?.properties?.readMoreButtonText}
			mobileImage={
				content?.properties?.mobileImage
					? {
							url: content.properties.mobileImage.url,
							altText: content.properties.mobileImage.properties?.altText,
							focalPoint: {
								left: content.properties.mobileImage.focalPoint?.left,
								top: content.properties.mobileImage.focalPoint?.top,
							},
					  }
					: null
			}
			image={
				content?.properties?.image
					? {
							url: content.properties.image.url,
							altText: content.properties.image.properties?.altText,
							focalPoint: content.properties.image.focalPoint,
							imageCropping: content?.properties?.imageCropping,
							fileType: content.properties.image.properties?.umbracoExtension,
					  }
					: null
			}
			video={
				content?.properties?.video
					? {
							url: content.properties.video.url,
							poster: content.properties.video.poster,
							autoplay: settings?.properties?.autoplay || false,
							isMuted: settings?.properties?.isMuted || false,
							playOnMouseover: settings?.properties?.playOnMouseover || false,
					  }
					: null
			}
			linkButton={
				content?.properties?.link
					? {
							children: content.properties.link.name,
							href: content.properties.link.url,
							target: content.properties.link.target,
							title: content.properties.link.name,
					  }
					: null
			}
			linkButtonStyle={content?.properties?.buttonStyle}
		/>
	);
};
